import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-article-topics-mobile',
  templateUrl: './article-topics-mobile.component.html',
})
export class ArticleTopicsMobileComponent implements OnInit {
  @Input() vocabularies: any
  @Input() configCarousel: object
  @Output() redirectPage = new EventEmitter()
  carouselVocabularies = []

  ngOnInit(): void {
    let lengthSlide = 4
    if (this.vocabularies.length > 4) {
      for (let i = 0; i < this.vocabularies.length; i += lengthSlide) {
        let slide = this.vocabularies.slice(i, i + lengthSlide)
        this.carouselVocabularies.push({ slide: slide })
      }
    }
  }
}
